import { useState } from "react";
import AdminButton from "../../../core/admin/adminButton";
import AdminTextInput from "../../../core/admin/adminTextInput";
import AdminPage from "../../../core/admin/adminPage";
import AdminCard from "../../../core/admin/adminCard";
import AdminDetails from "../../../core/admin/adminDetails";
import { SearchLineIcon } from "../../../../img/svg/adminIcons";
import BuyerScoreCard from "../../../core/buyerScoreCard";
import { IBuyerScore } from "../../../../utils/buyerScore";
import { useWatches } from "../../../../context/watchProvider";
import { formatPhoneNumber } from "../../../../utils/functions";

interface IFoundUser {
    id: string;
    name: string;
    email: string;
    phoneNumber: string;
}

export default function BuyerLookup() {

    const { getUserByEmail, getBuyerScore } = useWatches();

    const [email, setEmail] = useState("");
    const [userLoading, setUserLoading] = useState(false);
    const [userFeedback, setUserFeedback] = useState("");
    const [foundUser, setFoundUser] = useState<IFoundUser | null>(null);
    const [buyerScore, setBuyerScore] = useState<IBuyerScore | null>(null);
    const [buyerScoreLoading, setBuyerScoreLoading] = useState(false);

    const searchByEmail = async () => {
        try {
            setUserLoading(true);
            setUserFeedback("");
            setFoundUser(null);
            setBuyerScore(null);
            const user = await getUserByEmail(email);
            if (!user) {
                setUserFeedback("Usuário não encontrado");
                setUserLoading(false);
                return null;
            }
            setFoundUser(user);
            setUserLoading(false);
            setBuyerScoreLoading(true);
            const score = await getBuyerScore(user.id);
            setBuyerScore(score);
            setBuyerScoreLoading(false);
        } catch (error) {
            console.log(error);
            setUserLoading(false);
            setBuyerScoreLoading(false);
            setUserFeedback("Erro ao buscar usuário");
        }
    }

    return (
        <AdminPage title="Consultar Comprador" description="Pesquise pelo e-mail informado pelo comprador para ver seu score na plataforma antes de fechar negócio.">
            <AdminCard>
                <div className="flex flex-col sm:flex-row gap-2 max-w-xl">
                    <AdminTextInput type="email" placeholder="comprador@email.com" value={email} onChange={e => setEmail(e.target.value)} onEnter={email === "" ? undefined : searchByEmail} />
                    <AdminButton icon={<SearchLineIcon width="16px" />} loading={userLoading} disabled={email === ""} onClick={searchByEmail}>Buscar</AdminButton>
                </div>
                {
                    userFeedback ?
                        <p className="mt-3 text-sm font-semibold text-red-600">{userFeedback}</p>
                        : null
                }
            </AdminCard>
            {
                foundUser ?
                    <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.3fr)] gap-6 items-start">
                        <AdminCard title="Comprador">
                            <AdminDetails
                                columns={1}
                                items={[
                                    { label: "Nome", value: foundUser.name },
                                    { label: "E-mail", value: foundUser.email },
                                    { label: "Telefone", value: formatPhoneNumber(foundUser.phoneNumber) },
                                ]}
                            />
                        </AdminCard>
                        <BuyerScoreCard buyerScore={buyerScore} loading={buyerScoreLoading} variant="full" />
                    </div>
                    : null
            }
        </AdminPage>
    )
}
